import { useState } from 'react';
import { CiLogin } from 'react-icons/ci';
import { useTranslation } from 'react-i18next';
import UsePhoneInput from '@/components/Use/UsePhoneInput/UsePhoneInput';
import { useNavigate } from 'react-router-dom';
import SetUserApi from '@/services/api/setUserApi';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PhoneLoginForm = ({ requestPending }) => {
  const [phone, setPhone] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { SendVerifyCode } = SetUserApi();
  const navigate = useNavigate();

  const isSubmit = phone.trim().length >= 10;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isSubmit) {
      toast.error('Telefon numarası en az 10 hane olmalıdır.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await SendVerifyCode(phone);
      if (response?.success) {
        navigate('/auth/verify', {
          state: { userName: phone, phoneLoginFL: true }
        });
      } else {
        toast.error('Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      toast.error('Bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="grid border-b-2 py-2  text-sm">
      <ToastContainer />
      {/* PhoneInput Bileşeni */}
      <div className="flex justify-center my-2">
        <UsePhoneInput
          className="!w-full mx-6"
          value={phone}
          onChange={setPhone}
        />
      </div>

      {/* Giriş Butonu */}
      <div className="flex justify-center my-2">
        <button
          className={`flex items-center px-10 py-2 bg-color-button text-white rounded-md shadow-md transition-opacity duration-500 hover:opacity-50 ${
            !isSubmit || requestPending ? 'cursor-not-allowed' : ''
          }`}
          type="submit"
          disabled={!isSubmit || requestPending}>
          {isLoading ? (
            <div className="loader"></div>
          ) : (
            <>
              <CiLogin size={28} className="inline-block mr-2" />
              <p className="m-0">{t('Giris')}</p>
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default PhoneLoginForm;
